import { render, staticRenderFns } from "./EditorPropertyVideo.vue?vue&type=template&id=4881b85d&lang=pug"
import script from "./EditorPropertyVideo.vue?vue&type=script&lang=js"
export * from "./EditorPropertyVideo.vue?vue&type=script&lang=js"
import style0 from "./EditorPropertyVideo.vue?vue&type=style&index=0&id=4881b85d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports